export const caseStudies = [
  {
    id: 1,
    title: 'Uluslararası Şirket Birleşmesi',
    category: 'Kurumsal Hukuk',
    challenge: 'Türkiye\'de faaliyet gösteren bir teknoloji şirketi ile Avrupa merkezli bir yazılım şirketinin birleşme sürecinde karmaşık hukuki ve düzenleyici engeller.',
    solution: 'Kapsamlı due diligence süreci, çok yargılı hukuki analiz, rekabet kurumu onayları ve hissedar anlaşmalarının stratejik yapılandırılması.',
    outcome: 'Başarılı birleşme tamamlandı, 150 milyon USD değerinde işlem gerçekleştirildi, her iki tarafın çıkarları korundu.',
    duration: '8 ay',
    image: 'https://public.readdy.ai/ai/img_res/7674a0426b04c9f7ee0d4b4d68008965.jpg',
  },
  {
    id: 2,
    title: 'Büyük Ölçekli Gayrimenkul Uyuşmazlığı',
    category: 'Gayrimenkul Hukuku',
    challenge: 'İstanbul\'da 50 milyon USD değerindeki bir ticari gayrimenkul projesinde yüklenici ile proje sahibi arasında ciddi uyuşmazlık ve inşaatın durması.',
    solution: 'Detaylı sözleşme analizi, teknik bilirkişi raporlarının incelenmesi, arabuluculuk süreci yönetimi ve stratejik müzakere.',
    outcome: 'Mahkeme sürecine gitmeden anlaşma sağlandı, proje tamamlandı, müvekkilimiz 12 milyon USD tazminat aldı.',
    duration: '6 ay',
    image: 'https://readdy.ai/api/search-image?query=modern%20commercial%20real%20estate%20building%20under%20construction%20with%20glass%20facade%20large%20scale%20urban%20development%20project%20professional%20architectural%20photography%20natural%20lighting&width=600&height=400&seq=cs2&orientation=landscape',
  },
  {
    id: 3,
    title: 'Karmaşık Ticari Tahkim Davası',
    category: 'Ticari Dava',
    challenge: 'Uluslararası distribütörlük sözleşmesinin feshi sonrası 25 milyon USD\'lik tazminat talebi ve ICC tahkim süreci.',
    solution: 'Güçlü hukuki savunma stratejisi, uluslararası hukuk uzmanlarıyla işbirliği, kapsamlı delil sunumu ve etkili çapraz sorgu.',
    outcome: 'Tahkim heyeti müvekkilimiz lehine karar verdi, karşı tarafın tazminat talebi reddedildi, müvekkilimiz 8 milyon USD tazminat aldı.',
    duration: '14 ay',
    image: 'https://readdy.ai/api/search-image?query=professional%20international%20arbitration%20hearing%20room%20with%20panel%20table%20and%20formal%20legal%20setting%20serious%20judicial%20atmosphere%20modern%20conference%20space%20premium%20legal%20photography&width=600&height=400&seq=cs3&orientation=landscape',
  },
  {
    id: 4,
    title: 'Yabancı Yatırımcı İçin Şirket Kuruluşu',
    category: 'Yatırım Hukuku',
    challenge: 'Ortadoğu merkezli bir yatırım fonunun Türkiye\'de enerji sektöründe 200 milyon USD\'lik yatırım için şirket yapılandırması ve izin süreçleri.',
    solution: 'Optimal şirket yapısının belirlenmesi, yatırım teşvik belgesi alınması, sektörel izinlerin koordinasyonu ve vergi planlaması.',
    outcome: 'Başarılı şirket kuruluşu, tüm izinler alındı, yatırım teşviklerinden maksimum faydalanma sağlandı.',
    duration: '5 ay',
    image: 'https://readdy.ai/api/search-image?query=modern%20energy%20sector%20investment%20with%20solar%20panels%20and%20wind%20turbines%20professional%20renewable%20energy%20project%20large%20scale%20infrastructure%20premium%20industrial%20photography%20natural%20lighting&width=600&height=400&seq=cs4&orientation=landscape',
  },
  {
    id: 5,
    title: 'Yüksek Profilli Boşanma Davası',
    category: 'Aile Hukuku',
    challenge: 'Yüksek net değerli bir çiftin karmaşık mal varlığı, çocuk velayeti ve uluslararası unsurlar içeren boşanma süreci.',
    solution: 'Hassas müzakere süreci, çocukların üstün yararının korunması, adil mal paylaşımı ve gizlilik protokolleri.',
    outcome: 'Anlaşmalı boşanma sağlandı, çocukların velayeti ve ziyaret hakları düzenlendi, mal varlığı adil şekilde paylaşıldı.',
    duration: '10 ay',
    image: 'https://readdy.ai/api/search-image?query=elegant%20private%20legal%20consultation%20room%20with%20comfortable%20seating%20and%20warm%20professional%20atmosphere%20modern%20law%20office%20interior%20compassionate%20setting%20premium%20office%20photography&width=600&height=400&seq=cs5&orientation=landscape',
  },
  {
    id: 6,
    title: 'Ekonomik Suç Savunması',
    category: 'Ceza Hukuku',
    challenge: 'Şirket yöneticisine yönelik karmaşık ekonomik suç iddiaları ve tutuklama talebi.',
    solution: 'Güçlü savunma stratejisi, detaylı mali belge analizi, bilirkişi raporları ve etkili hukuki argümanlar.',
    outcome: 'Tutuklama talebi reddedildi, soruşturma aşamasında kovuşturmaya yer olmadığı kararı alındı.',
    duration: '7 ay',
    image: 'https://readdy.ai/api/search-image?query=serious%20criminal%20defense%20courtroom%20with%20judges%20bench%20and%20legal%20documents%20professional%20judicial%20setting%20traditional%20law%20court%20interior%20premium%20legal%20photography%20natural%20lighting&width=600&height=400&seq=cs6&orientation=landscape',
  },
];